import type { Cues } from '@studio/types';

const sortCuesByPosition = (cues: Readonly<Cues.Derived.CueWithUser[]>) => {
  return cues.slice().sort((a, b) => a.position.localeCompare(b.position));
};

export default sortCuesByPosition;
